<app-breadcrumb [title]="'All Markets'|translate" [breadcrumb]="'All Markets'|translate"></app-breadcrumb>
<!-- section start -->
<section class="section-b-space">
  <div class="container">
    <div class="row">





      <div class="col-lg-10">





        <!-- orders -->
        <div class="dashboard-right">
          <div class="dashboard">

            <div class="page-title">
              <h2>{{'We can buy products and ship it to any city in Iraq'|translate}}</h2>
              <h4>{{'Please click'|translate}} <a [routerLink]="['/shop/onlineMarket']">{{'here'|translate}} </a> {{'to
                order'|translate}} </h4>


            </div>










            <div class="container" *ngIf="(markets$|async) as markets">
              <div class="row">
                <div class="col-sm " *ngFor="let market of markets"
                  style="border: 0.5px solid rgb(230, 211, 211); margin: 2px;">
                  <div style="margin-top: 15px;">
                    <a (click)="openLink(market.domain)" style="cursor: pointer;">
                      <img [src]="onDisplayImage(market.imageUrl)" class="center" />
                      <br />
                      <span> {{websiteName(market.domain)}}</span>
                    </a>
                  </div>
                </div>

              </div>
            </div>


          </div>
        </div>









      </div>
    </div>
  </div>
</section>
<!-- section end -->